import { render, staticRenderFns } from "./CreateVoltage.vue?vue&type=template&id=08306b28&scoped=true"
import script from "./CreateVoltage.vue?vue&type=script&lang=js"
export * from "./CreateVoltage.vue?vue&type=script&lang=js"
import style0 from "./CreateVoltage.vue?vue&type=style&index=0&id=08306b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08306b28",
  null
  
)

export default component.exports